import { getVeedEmbedUrl } from "helpers/veed";
import { getYouTubeEmbedUrl } from "helpers/youtube";

const VEED_URL_PATTERN = /^https?:\/\/([^/]+\.)?veed\.io\//;

export const isVeedUrl = (videoUrl: string): boolean =>
  VEED_URL_PATTERN.test(videoUrl);

export const getTutorialEmbedUrl = (videoUrl: string): string =>
  isVeedUrl(videoUrl)
    ? getVeedEmbedUrl(videoUrl)
    : getYouTubeEmbedUrl(videoUrl);
